// extracted by mini-css-extract-plugin
export var markdown = "_sg-0";
export var tableWrapper = "_sg-1";